import React, { useEffect } from 'react';
const PIXEL_ID = '1017741007997101';
export function MetaPixel() {
  useEffect(() => {
    if (document.getElementById('meta-pixel-code')) return;
    const script = document.createElement('script');
    script.id = 'meta-pixel-code';
    script.innerHTML = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${PIXEL_ID}');
fbq('track', 'PageView');`;
    document.head.appendChild(script);
  }, []);
  return <noscript data-id="element-152" data-mp="mle2wzs5fdht">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-153" data-mp="mkus030x1pda" />
    </noscript>;
}